<div class="" id="subnav-menu" *ngIf="subMenu?.length > 1">
    <p-tabView [activeIndex]="index" (onChange)="handleChange($event)">
        <ng-container *ngIf="!isRecurso">
            <ng-container *ngFor="let sub of subMenu; let i = index">
                <p-tabPanel header="{{sub.nm_formulario}}">
                </p-tabPanel>
            </ng-container>
        </ng-container>
    </p-tabView>
</div>